import {createAction} from '@reduxjs/toolkit';


export const getQuicksightEmbeddedUrlRequest = createAction('GET_EMBEDDED_URL_REQUEST');
export const getQuicksightEmbeddedUrlSuccess = createAction('GET_EMBEDDED_URL_SUCCESS');
export const getQuicksightEmbeddedUrlFailed = createAction('GET_EMBEDDED_URL_FAILED');

export const setIdDashboardSelected = createAction('SET_ID_DASH_SELECTED');

export const resetDateExpired = createAction('RESET_DATE_EXPIRED');
